import Alpine from 'alpinejs'

import intersect from '@alpinejs/intersect'

import Adds from './components/adds'
import AsyncForm from './components/async-form'
import DarkMode from './components/dark-mode'
import MobileBranding from './components/mobile-branding'
import InstagramEmbed from './components/instagram-embed'

window.golfovinkyAsyncForm = AsyncForm

window.Alpine = Alpine

Alpine.plugin(intersect)

Alpine.data('adds', Adds)
Alpine.data('darkMode', DarkMode)
Alpine.data('mobileBranding', MobileBranding)
Alpine.data('instagramEmbed', InstagramEmbed)

Alpine.start()
